if(!customElements.get('logos-slider')) {
  customElements.define(
    'logos-slider',
    class LogosSlider extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) return console.error("Unable to initialize logos slider without a slider element.");

        this.sliderInstance = new Swiper(this.sliderEl, {
          loop: true,
          speed: 7000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false
          },
          slidesPerView: 1.5,
          spaceBetween: 0,
          centered: true,
          breakpoints: {
            640: 2.5,
            768: {
              slidesPerView: 4,
              centered: false,
            },
            1024: {
              slidesPerView: 6,
              centered: false
            }
          }
        });

        this.addEventListener('mouseenter', () => {
          this.sliderInstance.autoplay.stop();
          this.sliderEl.querySelector('.swiper-wrapper').style.transitionDuration = '0ms';
        });

        this.addEventListener('mouseleave', () => {
          this.sliderInstance.autoplay.start();
        });
      }
    }
  );
}
